const LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist";
const LOCAL_STORAGE_DELIMITER = ",";
const BUTTON_ACTIVE_CLASS = "active";
const GRID_LOADED_CLASS = "loaded";
const selectors = {
  button: "[button-wishlist]",
  grid: "[grid-wishlist]",
  productCard: "product-card",
};

document.addEventListener("DOMContentLoaded", () => {
  initButtons();
 
  initGrid();
});

document.addEventListener("shopify-wishlist:updated", (event) => {
  console.log("[Shopify Wishlist] Wishlist Updated ✅", event.detail.wishlist);

  //console.log(event.detail.wishlist.length);

  const lastItem = localStorage.getItem("LastWishlist");
  //console.log("Last Item " +lastItem);

  if (lastItem > event.detail.wishlist.length) {
    document.getElementById("updated-wish").textContent =
      "Item removed successfully";
    localStorage.setItem("LastWishlist", event.detail.wishlist.length);
  } else {
    // console.log('Item Added');

    document.getElementById("updated-wish").textContent =
      "Item added successfully";
    localStorage.setItem("LastWishlist", event.detail.wishlist.length);
  }
  document.getElementById("updated-wish").style.display = "block";
  setTimeout(function () {
    document.getElementById("updated-wish").style.display = "none";
  }, 3000);
  // console.log(event.detail.wishlist[event.detail.wishlist.length - 1]);
  if (event.detail.wishlist.length > 0) {
    document
      .querySelectorAll(".wishlist-header-counter")
      .forEach((element, index) => {
        element.classList.add("active");
      });

    document
      .querySelectorAll(".wishlist-header-counter")
      .classList.add("active");
    document.querySelector(".clearwish").style.display = "block";
    document.querySelector(".emptywish").style.display = "none";
  } else {
    // document.querySelector('.wishlist-header-counter').classList.remove("active");
    document
      .querySelectorAll(".wishlist-header-counter")
      .forEach((element, index) => {
        element.classList.remove("active");
      });
    document.querySelector(".clearwish").style.display = "none";
    document.querySelector(".emptywish").style.display = "block";
  }

  initGrid();
});

document.addEventListener("shopify-wishlist:init-product-grid", (event) => {
console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener("shopify-wishlist:init-buttons", (event) => {
  const urlHandhler = "https://studiodeve.com/pages/wishlist";
 console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
  if (event.detail.wishlist.length > 0) {
    // document.querySelector('.wishlist-header-counter').classList.add("active");
    document
      .querySelectorAll(".wishlist-header-counter")
      .forEach((element, index) => {
        element.classList.add("active");
      });

    if (window.location.href == urlHandhler) {
      document.querySelector(".clearwish").style.display = "block";
      document.querySelector(".emptywish").style.display = "none";
    }
  } else {
    document
      .querySelectorAll(".wishlist-header-counter")
      .forEach((element, index) => {
        element.classList.remove("active");
      });
    // document.querySelector('.wishlist-header-counter').classList.remove("active");
    if (window.location.href == urlHandhler) {
      document.querySelector(".clearwish").style.display = "none";
      document.querySelector(".emptywish").style.display = "block";
    }
  }
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((res) => res.text())
    .then((res) => {
      const text = res;
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, "text/html");

      const productCard = htmlDocument.documentElement.querySelector(
        selectors.productCard
      );
      // console.log(productCard);
      return productCard.outerHTML;
    })
    .catch((err) =>
      console.error(
        `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
        err
      )
    );
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join("");
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();
  
  const event = new CustomEvent("shopify-wishlist:init-product-grid", {
    detail: { wishlist: wishlist },
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        "[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist."
      );
    if (wishlistContains(productHandle))
      button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener("click", () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid ) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent("shopify-wishlist:init-buttons", {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent("shopify-wishlist:updated", {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);
  return array.length;
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};
